import { DEV_LOGIN_URL } from "@shared/constants/login-urls";

export const environment = {
    production: false,
    slug: "login",
    name: "development",
    baseServerUrl: "https://services-dev.revolab.tech/api",
    serverUrl: "https://services-dev.revolab.tech/api/lis",
    baseSiteUrl: "https://dev.revolab.tech/lis/",
    socketUrl: "wss://lis-ws.revolab.tech/dev",
    wsHttpEndpoint: "https://lis-http.revolab.tech/dev",
    loginWithRevolabUrl:"/auth",
    siteUrl: DEV_LOGIN_URL,
    application: "revolab-login",
    project: "revolab-lis",
    version: "1.0.0",
    tolgeeApiUrl: 'https://translations.revolab.tech',
    tolgeeApiKey: '',
    tolgeeCdn: '',
    tolgeeNamespaces: ['login'],
    sentryDsn: "",
};
